// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3OCFR","title":"ClientCherryInfo_title__nIjsj","itemText":"ClientCherryInfo_itemText__3dKTG"};